import { Pipe, PipeTransform } from '@angular/core';
import { Emoji } from '../forum/emoji';
import { getAssetUrl } from './asset';

@Pipe({
    name: 'emojiImage',
    standalone: false
})
export class EmojiImagePipe implements PipeTransform {
  transform(content: string, args: Emoji[]): string {
    const ans = content.replace(/\\emoji\[\d+\]/g, (emojiFlag) => {
      const index = emojiFlag.match(/\d+/);
      const emoji = parseInt(index[0], 10);
      const imagePath = args[emoji]?.image.path;
      // class "emoji-image" style in shared\content-view\content-view.component.css
      return `<img alt="emoji" class="emoji-image" src="${
        imagePath ? getAssetUrl(imagePath) : ''
      }">`;
    });
    return ans;
  }
}
